/* eslint-disable no-console */
import React, { useContext, useMemo, useState, useEffect } from 'react';
import { AppConfig } from './configTypes';
import config from './config/config';

export interface AppContextProps {
  appConfig: AppConfig;
}

export const AppContext = React.createContext<AppContextProps | null>(null);

export const useAppContext = () => {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error('Wrap app with AppContextProvider');
  }
  return ctx;
};

interface Props {
  children: React.ReactNode;
}

export const AppContextProvider: React.FC<Props> = ({ children }: Props) => {
  const [appConfig, setAppConfig] = useState<AppConfig>(config);

  useEffect(() => {
    let broker_uid = new URLSearchParams(window.location.search).get(
      'broker_uid',
    );

    if (!broker_uid) {
      broker_uid = localStorage.getItem('broker_uid');
    }

    if (broker_uid) {
      localStorage.setItem('broker_uid', broker_uid);
      // @ts-ignore
      setAppConfig(state => ({
        ...state,
        broker_uid,
      }));
    }
  }, []);

  const value = useMemo(
    () => ({
      appConfig,
    }),
    [appConfig],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
